// extracted by mini-css-extract-plugin
export default {"projectsList":"contractsList_projectsList__Q+UJo"};